import { pathJoin } from 'src/reducers/routing/utils'

export const createRouteProblemErrorsRoutesMap = (prefix: string) => ({
  '/:id': (id = ':id') => pathJoin(prefix)(id).chain,
})
